import { render, staticRenderFns } from "./FollowUpPatientStep11Component.vue?vue&type=template&id=4d039854&scoped=true&"
import script from "./FollowUpPatientStep11Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep11Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep11Component.vue?vue&type=style&index=0&id=4d039854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d039854",
  null
  
)

export default component.exports